module.exports = __webpack_public_path__ + "img/master_card.d296d668.png";